// extracted by mini-css-extract-plugin
export default {"wrap":"wrap__HGuxh","otherInput":"otherInput__+WATT","smallOtherInput":"smallOtherInput__a+c+2"};